// UI texts: skills (krug 5, K10: one tree for every survivor)
export default {
  title: 'Skills',
  back: 'Back',
  error: 'Could not load your skills.',
  treeLabel: 'Skill tree',
  build: 'Build',
  noBuild: 'No build yet',
  noBuildSub: 'learn your first node',
  points: 'points',
  pointOne: '1 point',
  pointMany: '{n} points',
  pendingShort: '{n} pending',
  pendingLong: '{n} pending · not applied yet',
  undo: 'Undo',
  apply: 'Apply ({pts})',
  reset: 'Reset',
  resetNothing: 'Nothing learned yet',
  resetTree: 'Reset skill tree',
  resetDone: 'Skill points are back',
  openTree: 'Open full tree',
  list: 'List',
  clear: 'Clear selection',
  zoomIn: 'Zoom in',
  zoomOut: 'Zoom out',
  fit: 'Fit tree',
  background: 'Background',
  startText: '{name} background start',
  oneKeystone: 'One keystone only',
  cost: 'Cost: {text}',
  locks: 'Learning this locks: {names}',
  kind: { small: 'Small', notable: 'Notable', keystone: 'Keystone', start: 'Start' },
  state: {
    start: 'Your starting point',
    learned: 'Learned',
    pending: 'Pending · apply to confirm',
    blocked: 'Other background',
    locked: 'Locked',
    outOfReach: 'Out of reach',
    noPoints: 'No points left',
    availableOne: 'Available · 1 point',
    path: 'Path · {pts}',
  },
  why: {
    blocked: 'Only {name}s start here',
    keyLearned: 'One keystone only · {name} is learned',
    keyPending: 'One keystone only · {name} is pending',
    noPath: 'No path from your nodes',
    firstPoint: 'Your first point comes at level 2',
    allSpent: 'All points spent',
    needs: 'Needs {pts}, you have {n}',
    dependents: 'Other pending nodes depend on this',
  },
  btn: {
    start: 'Starting point',
    learned: 'Learned',
    remove: 'Remove',
    oneKeystone: 'One keystone only',
    need: 'Need {pts}',
    learnOne: 'Learn · 1 point',
    learnPath: 'Learn path · {pts}',
  },
  tip: { locks: 'Locks other keystones', learned: 'Learned', pending: 'Pending' },
  noneSelected: 'No node selected',
  noneSelectedHint: 'Click a node to learn it, with the path to it. Hover a far node to see the path and its cost.',
  bonuses: 'Bonuses',
  nothingYet: 'Nothing learned yet.',
  legend: { small: 'Small', notable: 'Notable', keystone: 'Keystone', start: 'Start', learned: 'Learned', pending: 'Pending', available: 'Available', locked: 'Locked' },
  /** 29. 9. 2026: the screen before level 5 (the menu entry is locked; a direct link lands here). */
  locked: {
    title: 'The skill tree opens at level {n}',
    body: 'You earn 1 skill point per level from level 2 and can spend them from level 5.',
    points: 'Waiting: {n}',
  },
  intro: {
    title: 'Your tree starts here',
    body: 'You earn 1 skill point per level from level 2 and can spend them from level 5. Start at your {bg} background and learn a node connected to it; the highlighted ones are your first choices.',
    ok: 'Got it',
  },
  sector: { core: 'Core', melee: 'Melee', tank: 'Tank', scav: 'Scavenger', ranged: 'Ranged', stealth: 'Stealth', evasion: 'Evasion' },
  sectorLabel: { core: 'Core', melee: 'Melee', tank: 'Tank', scav: 'Scavenger / Crafter', ranged: 'Ranged', stealth: 'Stealth', evasion: 'Evasion' },
  tab: { core: 'Core', melee: 'Melee', tank: 'Tank', scav: 'Scav', ranged: 'Ranged', stealth: 'Stealth', evasion: 'Evasion' },
  tabAria: '{name}, {got} of {total} learned',
  nextIn: 'Next in {name}',
  learnedIn: 'Learned in {name}',
  smallNode: 'Small node',
  tagPending: 'PENDING',
  complete: '{name} complete',
  completeBody: 'Everything you can learn here is learned.',
  completeLocked: '{name} stays locked: one keystone only.',
  resetDialog: {
    title: 'Reset skill tree?',
    body: 'All {pts} return to you and every node except your start is cleared.',
    freeTest: 'Free during the test',
    firstFree: 'First reset free · next 100 Scrap',
    costs: 'You have {have} Scrap',
    notEnough: 'Not enough Scrap · you have {have}',
    free: 'FREE',
    scrap: '{n} SCRAP',
    cancel: 'Cancel',
    confirmFree: 'Reset · Free',
    confirmCost: 'Reset · {n} Scrap',
  },
  stat: {
    meleeDamagePct: 'Melee damage',
    rangedDamagePct: 'Ranged damage',
    damagePct: 'All damage',
    rangedCritPct: 'Ranged crit',
    openingShotDamagePct: 'Opening shot damage',
    accuracy: 'Accuracy',
    ambushDamagePct: 'Ambush damage',
    attackBelow30HpPct: 'Attack below 30% HP',
    maxHp: 'Max HP',
    maxHpPct: 'Max HP',
    defense: 'Defense',
    defensePct: 'Defense',
    healingPct: 'Healing',
    dodgePct: 'Dodge',
    escapePct: 'Escape',
    initiativePct: 'Initiative',
    stealthPct: 'Stealth',
    encounterChancePct: 'Encounter chance',
    lootPct: 'Loot',
    extraItemPct: 'Extra item chance',
    capacity: 'Capacity',
    craftMaterialsPct: 'Crafting materials',
    expeditionTimePct: 'Expedition time',
    mealEffectPct: 'Meal effect',
    allAttributes: 'All attributes',
  },
  special: {
    damageVsLowHpPct: '+{v}% damage to targets below 20% HP',
    hpAfterWinPct: 'Heal {v}% HP after winning a fight',
    openingShotAlwaysCrit: 'Your opening ranged shot is always a critical hit',
    dodgeCap: 'Dodge limit rises to {v}%',
    craftRollMinPts: 'Better affix rolls when crafting',
  },
} as const;
